import type { RootState } from 'store'
import type { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'
import type { ClientState } from './types'

export const client: Module<ClientState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
